var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container mt-3" }, [
      !_vm.hasStarted
        ? _c("div", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c("span", { staticClass: "header header-2" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("numbers_test.adjust_volume")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center mt-5" }, [
              _c(
                "button",
                {
                  staticClass: "button primary",
                  attrs: { type: "button" },
                  on: { click: _vm.startStage }
                },
                [_vm._v(_vm._s(_vm.$t("actions.start")))]
              )
            ]),
            _vm._v(" "),
            _c("br")
          ])
        : _c(
            "div",
            { staticClass: "pt-5 d-flex flex-column align-items-center" },
            [
              _c(
                "fade-transition",
                { attrs: { duration: 250, mode: "out-in" } },
                [
                  _vm.countdown.value > 0
                    ? _c(
                        "div",
                        {
                          key: "countdown",
                          staticClass: "d-flex justify-content-center mb-5"
                        },
                        [
                          _c("span", {
                            staticClass: "header header-bolder",
                            domProps: {
                              textContent: _vm._s(_vm.countdown.value)
                            }
                          })
                        ]
                      )
                    : _c("div", { key: "hearing-test" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center mb-5" },
                          [
                            _c("span", { staticClass: "header header-2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("second_stage.instructions_message")
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "hearing-test-main d-flex w-100" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-end sound-wrapper"
                              },
                              [
                                _vm.showLeftAnimation
                                  ? _c("img", {
                                      staticClass: "sound-waves mr-2 mb-5",
                                      attrs: { src: _vm.leftImage }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("img", {
                                staticClass: "hearing-test-button",
                                attrs: { src: "public/ear.svg", alt: "" },
                                on: { click: _vm.saveUserInput }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-start" },
                              [
                                _vm.showRightAnimation
                                  ? _c("img", {
                                      staticClass: "sound-waves mr-2 mb-5",
                                      attrs: { src: _vm.rightImage }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ])
                ]
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center mt-md-5" }, [
      _c("img", {
        staticClass: "sound-icon",
        attrs: { src: "public/sound.svg", alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }